import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {MensagemService} from '../../pages/gestor/shared/services/mensagem.service';
import {Util} from '../../utils/util';

@Component({
  selector: 'app-modal-responder-solicitacao',
  templateUrl: './modal-responder-solicitacao.component.html',
  styleUrls: ['./modal-responder-solicitacao.component.scss'],
})
export class ModalResponderSolicitacaoComponent implements OnInit {

    tipoSolicitacao = 'Desligamento';

    public modalForm: FormGroup;
    public validationMessages = {
        justificativa: [
            {type: 'required', message: 'Justificativa é obrigatório.'}
        ],
        tipoSolicitacao: [
            {type: 'required', message: 'Solicitacao é obrigatório.'}
        ]
    };

    constructor(
        private modalController: ModalController,
        private formBuilder: FormBuilder,
        private mensagemService: MensagemService
    ) {
        this.modalForm = this.formBuilder.group({
            id: [''],
            tipoSolicitacao: [''],
            justificativa: ['', Validators.required],
        }, {updateOn: 'blur'});
    }

    ngOnInit() {
        this.modalForm.get('tipoSolicitacao').setValue(this.tipoSolicitacao);
    }

    async enviar(opcao) {
        this.salvar();
    }

    async salvar() {
        if (this.modalForm.valid) {
            console.log('this.modalForm.getRawValue(): ', this.modalForm.getRawValue());
            await this.modalController.dismiss(true);
        } else {
            Util.touchAllControls(this.modalForm);
            await this.mensagemService.showToast('Preencha os campos corretamente.');
        }
    }

    async fechar(opcao) {
        await this.modalController.dismiss(true);
    }

}
